import { Text } from "@hackthenorth/north";
import React from "react";
import styled from "styled-components";

import {
  BannerBackground,
  BannerBronzeBackground,
  BannerSilverBackground,
  BannerGoldBackground,
  BannerForegroundBlue,
  HackPalBackground,
} from "src/static/img";
import { mediaQueries } from "src/theme/deviceBreakpoints";

import { medalProgression } from "../modals/hacker/home/quest/constants";

interface Props {
  balance: number;
  hackpal?: string;
  showBackground?: boolean;
  showForegroundBanner?: boolean;
}

const HackPalBanner = ({
  balance,
  hackpal,
  showBackground = true,
  showForegroundBanner = true,
}: Props) => {
  const currMilestone =
    Object.keys(medalProgression)
      .map(Number)
      .sort((a, b) => b - a)
      .find((milestone) => balance >= milestone) ?? null;

  const bannerTitle = currMilestone
    ? medalProgression[Number(currMilestone)].title
    : undefined;

  return (
    <ImageWrapper>
      {showForegroundBanner && bannerTitle && currMilestone && (
        <ForegroundBanner backgroundImg={BannerForegroundBlue}>
          <ForegroundText mods="heading white" length={bannerTitle.length}>
            {bannerTitle}
          </ForegroundText>
        </ForegroundBanner>
      )}
      {showBackground ? (
        <HackPalWrapper
          backgroundImg={
            currMilestone
              ? medalProgression[Number(currMilestone)].background
              : HackPalBackground
          }
        >
          {hackpal && <StyledImage src={hackpal} alt="HackPal" />}
        </HackPalWrapper>
      ) : (
        <ForegroundWrapper
          backgroundImg={
            currMilestone
              ? medalProgression[Number(currMilestone)].background
              : HackPalBackground
          }
        >
          {hackpal && <StyledImage src={hackpal} alt="HackPal" />}
        </ForegroundWrapper>
      )}
      {showBackground && (
        <StyledImage
          src={
            balance >= Number(Object.keys(medalProgression)[2])
              ? BannerGoldBackground
              : balance >= Number(Object.keys(medalProgression)[1])
              ? BannerSilverBackground
              : balance >= Number(Object.keys(medalProgression)[0])
              ? BannerBronzeBackground
              : BannerBackground
          }
          alt="Goose Games Banner Background"
        />
      )}
    </ImageWrapper>
  );
};

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;

const ForegroundWrapper = styled.div<{ backgroundImg: string }>`
  width: 100%;
  height: 100%;
  background-image: ${({ backgroundImg }) => `url(${backgroundImg})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const HackPalWrapper = styled.div<{ backgroundImg: string }>`
  width: 90%;
  height: 60%;
  background-image: ${({ backgroundImg }) => `url(${backgroundImg})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ForegroundBanner = styled.div<{ backgroundImg: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 20%;
  background-image: ${({ backgroundImg }) => `url(${backgroundImg})`};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 3;
  bottom: 20%;
  left: 0;
`;

const ForegroundText = styled(Text)<{ length: number }>`
  font-size: ${({ length }) => (length > 13 ? "12px" : "16px")} !important;
  white-space: nowrap;
  margin-bottom: 0px !important;

  ${mediaQueries.tablet} {
    font-size: ${({ length }) => (length > 13 ? "10px" : "14px")} !important;
  }
`;

export default HackPalBanner;
